
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.846 3.892a7.77 7.77 0 00-.741-1.03 7.98 7.98 0 00-12.954 9.242c.217.366.463.715.736 1.041.292.35.617.67.968.959a7.73 7.73 0 001.03.744 7.986 7.986 0 008.263 0A7.964 7.964 0 0016 8.024a7.941 7.941 0 00-1.154-4.132zm-2.612-1.106c.358.288.685.612.976.968l-2.113 2.112a3.705 3.705 0 00-.98-.962l2.117-2.118zm-1.707 5.238v.194a2.477 2.477 0 01-.294.995 2.53 2.53 0 01-2.013 1.309h-.398a2.51 2.51 0 01-2.006-1.315 2.49 2.49 0 01-.295-.98v-.203A2.516 2.516 0 016.84 5.818c.274-.151.574-.25.884-.294a2.744 2.744 0 01.606 0c.31.038.608.132.883.28.411.222.753.554.988.959.168.29.276.611.315.944.01.105.014.211.012.317zM8.019 1.298c1.097 0 2.177.268 3.146.782L8.882 4.362a3.859 3.859 0 00-1.745 0l-2.27-2.279a6.704 6.704 0 013.152-.785zM3.8 2.789l2.123 2.115a3.784 3.784 0 00-.98.964l-2.12-2.111c.293-.354.62-.679.977-.968zM1.29 8.024a6.672 6.672 0 01.807-3.208l2.268 2.267c-.153.59-.16 1.21-.02 1.803L2.072 11.17a6.71 6.71 0 01-.782-3.145zm1.49 4.212l2.119-2.114c.256.383.583.715.962.979l-2.113 2.111a6.572 6.572 0 01-.968-.976zm5.24 2.515a6.665 6.665 0 01-3.213-.824l2.266-2.265v.001c.62.16 1.27.16 1.889 0l2.257 2.268c-.98.536-2.08.819-3.199.82zm4.267-1.533l-2.112-2.114a3.77 3.77 0 00.965-.98l2.116 2.116a6.634 6.634 0 01-.968.976l-.001.002zm1.674-2.059L11.677 8.88a3.731 3.731 0 00-.017-1.815l2.266-2.264a6.695 6.695 0 01.035 6.36v-.002z"}})])
          )
        }
      }
    